<template>
  <div
    class="w-full px-4 py-2 flex tablet-h:rounded-[10px] tablet-h:p-1.5 tablet-h:pr-2.5"
    :class="classes"
    @click="handleRowClick"
  >
    <div class="relative mr-[9px] size-11 shrink-0 p-0.5">
      <div class="size-full rounded-[4px] bg-gray-200/30 p-0.5">
        <Thumbnail
          :type="fileTypeToThumbnail(file?.type)"
          :src="notification.primaryIcon.imageUrl ?? undefined"
        />
      </div>
      <Avatar
        v-if="notification.secondaryIcon?.imageUrl"
        class="absolute bottom-0 right-0 z-2"
        :size="18"
        :src="notification.secondaryIcon.imageUrl"
      />
    </div>
    <div
      class="text-[14px] leading-[19px] text-gray-800 -mt-1 flex flex-col justify-between"
    >
      <component :is="copy" class="mb-[3px]" />
      <div class="text-[12px] leading-[18px] opacity-60">
        {{ formatDistanceToNowStrict(props.notification.timestamp) }} ago
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  NotificationType,
  type FileMetadata,
  type Notification,
} from '@/shared/graphql/legacy/generated'
import { fileTypeToThumbnail } from '@/shared/utils/thumbnail'
import { Avatar, Thumbnail } from '@dacr/library'
import { formatDistanceToNowStrict } from 'date-fns'
import { computed, h } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps<{
  notification: Notification
}>()

const router = useRouter()

const file = computed(() => (props.notification.metadata as FileMetadata).file)

const classes = computed(() => ({
  'tablet-h:hover:bg-[#FAFAFA]': props.notification.read,
  'bg-green-700/10': !props.notification.read,
  'cursor-pointer': !!file.value?.copyrightId,
}))

const handleRowClick = () => {
  if (!file.value?.copyrightId) return

  router.push(`/file/${file.value.copyrightId}`)
}

const copy = computed(() => {
  if (props.notification.type === NotificationType.ReceivedFile) {
    return h('div', [
      'You are the new owner of the copyright for ',
      h('span', { class: 'font-medium break-all' }, file.value?.fileName),
      `. The file and Dacr token for this copyright have been moved into your account`,
    ])
  }

  if (props.notification.type === NotificationType.ReceivedLicense) {
    return h('div', [
      'You are now a licensee for the copyright of ',
      h('span', { class: 'font-medium break-all' }, file.value?.fileName),
      `. The file and Dacr license token for this copyright have been moved into your account`,
    ])
  }

  return null
})
</script>
